import * as React from 'react';
import routes from '@root/routes';
import type { SpaceProvider } from '@root/types';
import s from './SpaceProvider.module.less';

// Even thought this component uses the terminology "Building Owner"
// We kept the name of the component as SpaceProvider
// the final terminology is still not settled
// and the user facing terminology changes more often
// than we want to keep renaming code. When we feel like
// we are settled on a terminology, we can rename this component.

type LinkToSpaceProviderProps = {
  onClick: React.MouseEventHandler;
  slug: string | null;
  children: React.ReactNode;
};

const LinkToSpaceProvider = ({ slug, children, onClick }: LinkToSpaceProviderProps) =>
  slug ? (
    <a className={s.link} href={routes.landlords(slug)} onClick={onClick}>
      {children}
    </a>
  ) : (
    <> {children} </>
  );

type SpaceProviderInfoProps = {
  spaceProvider: SpaceProvider;
  onClick: Function;
};

const SpaceProviderInfo = ({ spaceProvider, onClick }: SpaceProviderInfoProps) => {
  return (
    <div className={s.container} data-testid="basic-building-space-provider-info">
      <LinkToSpaceProvider slug={spaceProvider.slug} onClick={onClick as React.MouseEventHandler}>
        <img
          className={s.logo}
          alt={spaceProvider.logo.description}
          src={spaceProvider.logo.path}
          data-testid="basic-building-space-provider-logo"
        />
      </LinkToSpaceProvider>
      <div className={s.name} data-testid="basic-building-space-provider-name">
        <LinkToSpaceProvider slug={spaceProvider.slug} onClick={onClick as React.MouseEventHandler}>
          <span className={s.providerName}>{spaceProvider.name}</span>
        </LinkToSpaceProvider>
      </div>
    </div>
  );
};

export default SpaceProviderInfo;
